import { createContext } from 'react';

import { TableContextState } from './types';

export const TableContext = createContext<TableContextState | undefined>(
  undefined
);
